import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import LaundryForm from '../form/laundry'
import {TableReceptionWrapper} from './component/table/reception'
import {TableWashWrapper} from './component/table/wash'
import {TableOutWrapper} from './component/table/out'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
const LaundryTab = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs
        className={'sdx_sub_react_tab_panel '}
        selectedIndex={currentTabItem.currentExternalTab}
        onSelect={(index) => {
          const obj: TabLavanderiaModel = {
            ...currentTabItem,
            currentExternalTab: index,
          }
          changeCurrentTabItem(obj)
        }}
      >
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('RECEPCION/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Recepción</Tab>
          )}
          {isAllowed('PROCESOLAVADO/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Proceso de Lavado</Tab>
          )}
          {isAllowed('SALIDA/ACCESO') && <Tab className={'sdx_sub_tab_panel_option'}>Salida</Tab>}
        </TabList>
        <TabPanel>
          <LaundryForm />
        </TabPanel>
        {isAllowed('RECEPCION/ACCESO') && (
          <TabPanel>
            <TableReceptionWrapper />
          </TabPanel>
        )}
        {isAllowed('PROCESOLAVADO/ACCESO') && (
          <TabPanel>
            <TableWashWrapper />
          </TabPanel>
        )}
        {isAllowed('SALIDA/ACCESO') && (
          <TabPanel>
            <TableOutWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default LaundryTab
